import { PoolNumber, PoolNumberFilterRequest } from "callable-data-objects";
import Page from "callable-data-objects/dist/services/Page";
import { useAccount } from "Hooks/Endpoints";
import { APINumberPoolContext } from "Providers/APIContexts";
import React, { useEffect, useState } from "react";
import { useAPI } from "./APIProvider";
import { APINumberPoolProps, DefaultProviderProps } from "./types";

const APINumberPoolProvider = ({ children }: DefaultProviderProps) => {
  const api = useAPI();
  const { account, select: selectAccount } = useAccount();
  const [ddis, setDDIs] = useState<Page<PoolNumber> | undefined>();
  const [ddi, setDDI] = useState<PoolNumber | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [filter, setFilter] = useState<PoolNumberFilterRequest | undefined>();

  useEffect(() => {
    setFilter({
      page: 0,
      max: 20,
      name: "",
      classification: ["standard"],
    });
  }, [api]);

  useEffect(() => {
    if (filter) {
      setLoading(true);
      api.poolService.filter(filter).then((resp) => {
        setDDIs(resp);
        setLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  async function search(value: string) {
    if (filter) {
      if (value.startsWith("0")) {
        value = value.substring(1);
      }
      setFilter({ ...filter, name: value });
    }
  }

  function select(id: string): void {
    setLoading(true);
    api.poolService.get(id).then((resp: PoolNumber) => {
      setDDI(resp);
      setLoading(false);
    });
  }

  function unselect() {
    setDDI(undefined);
  }

  async function assign() {
    if (account && ddi) {
      setLoading(true);
      await api.poolService.assign(account.id, ddi);
      await selectAccount(account.id);
      unselect();
      search("");
      setLoading(false);
    }
  }

  const numberPoolProps: APINumberPoolProps = {
    ddi,
    ddis,
    loading,
    select,
    unselect,
    search,
    assign,
    filter
  };

  return (
    <APINumberPoolContext.Provider value={numberPoolProps}>
      {children}
    </APINumberPoolContext.Provider>
  );
};

export default APINumberPoolProvider;
